import { useEffect, useState } from "react";
import SalesOrderServices from "../../Services/SalesOrder/SalesOrderServices";
import ConfigurationServices from "../../Services/Configuration/ConfigurationServices";
import { Box, Grid } from "@material-ui/core";
import { Style } from "./StockStyle";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router";
import ArrowForwardIcon from "@mui/icons-material/ArrowBack";
import ArrowCircleDown from "@mui/icons-material/ArrowCircleDown";
import ArrowCircleUp from "@mui/icons-material/ArrowCircleUp";
import SwitchRadio from "../../Utils/HookForm/SwitchRadio";
import GeneralButton from "../../Utils/GeneralButton/GeneralButton";
import Modal from "../../Utils/Modal/Modal";
import SelectInputAutoComplete from "../../Utils/HookForm/SelectInputAutoComplete";
import { useSelector } from "react-redux";
import { selectCommonData } from "../../Store/Slices/CommonDataSlice";
import { useForm } from "react-hook-form";
import WhiteSpace from "react-white-space";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Close from "@material-ui/icons/Close";
import * as Feather from "react-feather";

const Stock = () => {
  const classes = Style();
  const { t } = useTranslation("salesOrder");
  const [salesOrders, setSalesOrders] = useState<any>();
  const [visibleModal, setVisibleModal] = useState<boolean>(false);
  const [moodalContent, setModalContent] = useState<any>();
  const [allStock, setAllStock] = useState<boolean>(false);
  const [tempAllStock, setTempAllStock] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [visibleSmFilter, setVisibleSmFilter] = useState<boolean>(false);
  const [webInfos, setWebInfos] = useState<any>();
  const { state } = useLocation<any>();
  const CommonData = useSelector(selectCommonData);
  const brands = CommonData.allCars;
  const [carModels, setCarModels] = useState<any[]>([]);
  const [carTypes, setCarTypes] = useState<any[]>([]);
  const [colors, setColors] = useState<any>([]);
  const [manufactureYears, setManufactureYears] = useState<any[]>([]);
  const [states] = useState<any>([
    {
      id: "NEW",
      text: "صفر",
    },
    {
      id: "USED",
      text: "کارکرده",
    },
  ]);
  const {
    control,
    formState: { errors },
    getValues,
    setValue,
  } = useForm<any>({
    mode: "onBlur",
    reValidateMode: "onSubmit",
  });

  const history = useHistory();
  const getStock = (command: any) => {
    setLoading(true);
    SalesOrderServices.GetStock(command, (res) => {
      if (res.status == "0") {
        let index = 0;
        res.stocks.map((st: any) => {
          st.showDetails = false;
          st.id = index;
          index++;
        });
        res.stocks?.sort((a: any, b: any) => {
          return parseInt(b.count) - parseInt(a.count);
        });
        setSalesOrders(res.stocks);
        setLoading(false);
      } else {
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    ConfigurationServices.GetContactUsContent({}, (res) => {
      if (res.status?.toString() === "0") {
        console.log("Contact Us API Response:", res);
        setWebInfos(res);
      }
    });
  }, []);

  useEffect(() => {
    setLoading(true);
    let command: any = {
      pn: "1",
      pl: "100000",
    };
    if (!!state) {
      command = {
        brandId: state?.brand?.id,
        carModelId: state?.carModel?.id,
        carTypeId: state?.carType?.id,
        colorId: state?.color?.id,
        manufactureYearId: state?.manufactureYear?.id,
        mileageState: state?.state,
        pn: "1",
        pl: "100000",
      };
      !!state?.brand && brandChange(state?.brand);
      !!state?.carModel && carModelChange(state?.carModel);
      !!state?.carType && carTypeChange(state?.carType);
      setValue("brand", state?.brand);
      setValue("carModel", state?.carModel);
      setValue("carType", state?.carType);
      setValue("color", state?.color);
      setValue("manufactureYear", state?.manufactureYear);
      const mileageState = states.filter((s: any) => s.id === state?.state);
      setValue("mileageState", mileageState[0]);
    }
    getStock(command);
  }, []);
  const toggleDetails = (id: any) => {
    setSalesOrders((prevOrders: any) =>
      prevOrders.map((order: any) =>
        order.id === id ? { ...order, showDetails: !order.showDetails } : order
      )
    );
  };

  const brandChange = (value: any) => {
    if (!!getValues("carModel")) {
      setValue("carModel", null);
    }
    if (!!getValues("carType")) {
      setValue("carType", null);
    }
    if (!!getValues("color")) {
      setValue("color", null);
    }
    if (!!getValues("manufactureYear")) {
      setValue("manufactureYear", null);
    }
    if (!!value) {
      setCarModels(
        !!value.carModels && value.carModels.length !== 0 ? value.carModels : []
      );
    } else {
      setCarModels([]);
      setCarTypes([]);
    }
  };
  const carModelChange = (value: any) => {
    if (!!getValues("carType")) {
      setValue("carType", null);
    }
    if (!!getValues("color")) {
      setValue("color", null);
    }
    if (!!getValues("manufactureYear")) {
      setValue("manufactureYear", null);
    }
    if (!!value) {
      setCarTypes(
        !!value.carTypes && value.carTypes.length !== 0 ? value.carTypes : []
      );
    } else {
      setCarTypes([]);
    }
  };
  const carTypeChange = (value: any) => {
    if (!!value) {
      let ctmy: any = [];
      value.carTypeManufactureYears.map((ct: any) => {
        ctmy.push({
          id: ct?.manufactureYearId,
          description: ct?.persianYear + "-" + ct?.miladiYear,
        });
      });
      // const prcItems = [...value.priceItems];
      // prcItems?.sort((a: any, b: any) => a.description.localeCompare(b.description));
      // setPriceItems(prcItems);
      if (!!getValues("color")) {
        setValue("color", null);
      }
      if (!!getValues("manufactureYear")) {
        setValue("manufactureYear", null);
      }
      const clrs = [...value.carTypeColors];
      clrs?.sort((a: any, b: any) => a.color.localeCompare(b.color));
      setColors(clrs);
      const trmClrs = [...value.carTypeTrimColors];
      trmClrs?.sort((a: any, b: any) => a.color.localeCompare(b.color));
      setManufactureYears(ctmy);
    }
  };

  useEffect(() => { }, [visibleSmFilter]);
  const filterContent = (
    <>
      <div className={[classes.cart, "p-4"].join(" ")}>
        <SelectInputAutoComplete
          name="brand"
          options={brands}
          label=""
          classNames="mt-2"
          placeholder={t("brand")}
          control={control}
          english={true}
          withoutShrink={true}
          componentsProps={{ popper: { style: { zIndex: 1500 } } }}
          changeHandler={(value: string) => {
            setValue("brand", value);
            brandChange(value);
          }}
        />
        <SelectInputAutoComplete
          name="carModel"
          options={carModels}
          label=""
          classNames="mt-2"
          disable={carModels.length === 0}
          placeholder={t("carModel")}
          control={control}
          english={true}
          withoutShrink={true}
          componentsProps={{ popper: { style: { zIndex: 1500 } } }}
          changeHandler={(value: string) => {
            setValue("carModel", value);
            carModelChange(value);
          }}
        />
        <SelectInputAutoComplete
          name="carType"
          options={carTypes}
          disable={carTypes.length === 0}
          label=""
          classNames="mt-2"
          placeholder={t("carType")}
          control={control}
          english={true}
          withoutShrink={true}
          componentsProps={{ popper: { style: { zIndex: 1500 } } }}
          changeHandler={(value: any) => {
            setValue("carType", value);
            carTypeChange(value);
          }}
        />
        <SelectInputAutoComplete
          name="manufactureYear"
          options={manufactureYears}
          disable={manufactureYears.length === 0}
          label=""
          classNames="mt-2"
          placeholder={t("manufactureYear")}
          control={control}
          withoutShrink={true}
          componentsProps={{ popper: { style: { zIndex: 1500 } } }}
          changeHandler={(value: string) => {
            setValue("manufactureYear", value);
          }}
        />
        <SelectInputAutoComplete
          name="color"
          options={colors}
          disable={colors.length === 0}
          label=""
          classNames="mt-2"
          placeholder={t("color")}
          control={control}
          withoutShrink={true}
          componentsProps={{ popper: { style: { zIndex: 1500 } } }}
          changeHandler={(value: string) => {
            setValue("color", value);
          }}
        />
        <SelectInputAutoComplete
          name="mileageState"
          options={states}
          label=""
          classNames="mt-2"
          placeholder={t("mileageState")}
          control={control}
          withoutShrink={true}
          componentsProps={{ popper: { style: { zIndex: 1500 } } }}
          changeHandler={(value: string) => {
            setValue("mileageState", value);
          }}
        />
        <SwitchRadio
          name="allStock"
          label={t("allStock")}
          checked={tempAllStock}
          changeHandler={(
            event: React.ChangeEvent<HTMLInputElement>,
            value: boolean
          ) => {
            setTempAllStock(value);
          }}
        />
        <div className="row justify-content-center w-100 ml-0 mr-0">
          <Grid lg={6} md={6} sm={12} xs={12} className="mt-4">
            <GeneralButton
              clicked={() => {
                setAllStock(tempAllStock);
                const command = {
                  brandId: getValues("brand")?.id,
                  carModelId: getValues("carModel")?.id,
                  carTypeId: getValues("carType")?.id,
                  colorId: getValues("color")?.id,
                  total: tempAllStock ? "1" : "0",
                  manufactureYearId: getValues("manufactureYear")?.id,
                  mileageState: getValues("mileageState")?.id,
                  pn: "1",
                  pl: "100000",
                };
                getStock(command);
                setVisibleSmFilter(false);
              }}
              btnType="BlueBtn"
              text="اعمال فیلتر"
            />
          </Grid>
          <Grid lg={6} md={6} sm={12} xs={12} className="mt-4">
            <GeneralButton
              clicked={() => {
                setValue("brand", null);
                setValue("carModel", null);
                setValue("carType", null);
                setValue("color", null);
                setValue("manufactureYear", null);
                setValue("mileageState", null);
                getStock({ pn: "1", pl: "100000" });
                setVisibleSmFilter(false);
                setAllStock(false);
                setTempAllStock(false);
                setCarModels([]);
                setCarTypes([]);
                setManufactureYears([]);
                setColors([]);
              }}
              btnType="WhiteBtn"
              text="حذف فیلتر"
            />
          </Grid>
        </div>
      </div>
    </>
  );
  return (
    <>
      <div className="row justify-content-center w-100 ml-0 mr-0">
        <div style={{ maxWidth: "1600px", display: "flex" }}>
          <div className={classes.stockMain} style={{ width: "100%" }}>
            <div className="row justify-content-center w-100 ml-0 mr-0">
              <Grid item lg={11} md={11} sm={12} xs={12}>
                <Box
                  sx={{ marginTop: { xs: "10px", sm: "10px" } }}
                  className={classes.headerText}
                >
                  <div className="row justify-content-center w-100 ml-0 mr-0">
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                      <Box
                        sx={{
                          fontSize: {
                            xs: "14px",
                            sm: "14px",
                            md: "24px",
                            lg: "24px",
                          },
                        }}
                        className={classes.stockHdr}
                      >
                        {t("stocks")}
                      </Box>
                    </Grid>
                    <Grid
                      item
                      lg={6}
                      md={6}
                      sm={6}
                      xs={6}
                      style={{ textAlign: "left", lineHeight: "normal" }}
                    >
                      <div className="row w-100 ml-0 mr-0" dir="ltr">
                        <ArrowForwardIcon
                          sx={{
                            fontSize: {
                              xs: "30px",
                              sm: "30px",
                              md: "50px",
                              lg: "50px",
                            },
                          }}
                          className={classes.back}
                          onClick={() => {
                            history.goBack();
                          }}
                        />
                        <Box
                          sx={{
                            fontSize: {
                              xs: "14px",
                              sm: "14px",
                              md: "30px",
                              lg: "30px",
                            },
                          }}
                          className={classes.backBtn}
                          onClick={() => {
                            history.goBack();
                          }}
                        >
                          {t("back")}
                        </Box>
                      </div>
                    </Grid>
                  </div>
                </Box>
              </Grid>
            </div>
            <Box
              sx={{
                display: { xs: "block", sm: "block", md: "none", lg: "none" },
              }}
            >
              <div className="row w-100 ml-0 mr-0" id="filter_btn_id">
                <Feather.Filter
                  onClick={() => setVisibleSmFilter(true)}
                  className={classes.icons}
                />
                <WhiteSpace />
                فیلتر کنید...
              </div>
            </Box>

            <div className="row justify-content-start m-0">
              <div
                className={classes.puchsBtn}
                onClick={() => {
                  setModalContent(
                    <div className="row justify-content-center">
                      <Grid item lg={12} md={12} sm={11} xs={11}>
                        <div
                          className={[
                            classes.purchsCnt,
                            "row justify-content-center",
                          ].join(" ")}
                        >
                          {t("purchsCntnt")}
                        </div>
                        <div className="row justify-content-center pt-5">
                          <Grid item lg={4} md={4} sm={8} xs={8}>
                            <GeneralButton
                              btnType="BlueBtn"
                              text={t("prchsOrderTxt")}
                              clicked={() => {
                                history.push("/register-purchase-order");
                              }}
                            />
                          </Grid>
                        </div>
                      </Grid>
                    </div>
                  );
                  setVisibleModal(true);
                }}
                style={{ paddingLeft: "10px", width: "auto" }}
              >
                <div>{t("prchsOrderTxt")}</div>
                <div>
                  <LazyLoadImage
                    className="main-img"
                    width="15px"
                    height="15px"
                    alt="image Alt and Title"
                    src={
                      process.env.PUBLIC_URL + "/images/arrowPurchaseOrder.png"
                    }
                  />
                </div>
              </div>
            </div>
            <div className="row justify-content-center w-100 ml-0">
              <Box
                sx={{
                  display: { xs: "none", sm: "none", md: "block", lg: "block" },
                  width: "30%",
                }}
                className={[classes.stockMain, "mt-2"].join(" ")}
                style={{ backgroundColor: "white" }}
              >
                {filterContent}
              </Box>
              {visibleSmFilter && (
                <>
                  <Box
                    sx={{
                      display: {
                        xs: "block",
                        sm: "block",
                        md: "none",
                        lg: "none",
                      },
                      position: "fixed",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      bgcolor: "rgba(0, 0, 0, 0.5)",
                      zIndex: 1399,
                    }}
                    onClick={() => setVisibleSmFilter(false)}
                  />
                  <Box
                    sx={{
                      display: {
                        xs: "block",
                        sm: "block",
                        md: "none",
                        lg: "none",
                      },
                      width: "100%",
                      position: "absolute",
                      top: 80,
                      height: "fit-content",
                      zIndex: 1400,
                      marginBottom: 0,
                    }}
                    className={classes.stockMain}
                    style={{ backgroundColor: "white" }}
                  >
                    <Close onClick={() => setVisibleSmFilter(false)} />
                    {filterContent}
                  </Box>
                </>
              )}
              <Box
                className={classes.stockMain}
                sx={{
                  width: { xs: "100%", sm: "100%", md: "70%", lg: "70%" },
                  marginTop: { xs: visibleSmFilter ? 0 : "8px", sm: visibleSmFilter ? 0 : "8px", md: "0", lg: "0" }
                }}
              >
                {salesOrders?.map((s: any) => {
                  return (
                    <>
                      <Box
                        sx={{
                          display: {
                            xs: "none",
                            sm: "none",
                            md: "block",
                            lg: "block",
                          },
                        }}
                        className={classes.cart}
                      >
                        <div className={"row justify-content-center pt-4 mt-2"}>
                          <Grid
                            lg={3}
                            md={3}
                            sm={6}
                            xs={12}
                            className={classes.title}
                          >
                            مدل خودرو
                          </Grid>
                          <Grid
                            lg={3}
                            md={3}
                            sm={6}
                            xs={12}
                            className={classes.title}
                          >
                            <span style={{ display: allStock ? "none" : "" }}>
                              کارکرد
                            </span>
                          </Grid>
                          <Grid
                            lg={3}
                            md={3}
                            sm={6}
                            xs={12}
                            className={classes.title}
                          >
                            <span style={{ display: allStock ? "none" : "" }}>
                              سال ساخت
                            </span>
                          </Grid>
                          <Grid
                            lg={3}
                            md={3}
                            sm={6}
                            xs={12}
                            className={classes.title}
                          >
                            موجودی
                          </Grid>
                        </div>
                        <div className={"row justify-content-center mt-1 pb-4"}>
                          <Grid
                            lg={3}
                            md={3}
                            sm={6}
                            xs={12}
                            className={classes.title}
                          >
                            {s.brand}/{s.carModel}/{s.carType}
                          </Grid>
                          <Grid
                            lg={3}
                            md={3}
                            sm={6}
                            xs={12}
                            className={classes.title}
                          >
                            <span style={{ display: allStock ? "none" : "" }}>
                              {s.mileage === "0" ? "صفر" : "کارکرده"}
                            </span>
                          </Grid>
                          <Grid
                            lg={3}
                            md={3}
                            sm={6}
                            xs={12}
                            className={classes.title}
                          >
                            <span style={{ display: allStock ? "none" : "" }}>
                              {s.persianYear}
                            </span>
                          </Grid>
                          <Grid
                            lg={3}
                            md={3}
                            sm={6}
                            xs={12}
                            className={classes.title}
                          >
                            {s.count}
                          </Grid>
                        </div>
                        <div
                          className={"row justify-content-center m-0 mt-1 pb-2"}
                        >
                          <div style={{ borderTop: "1px solid #F3F3F3" }}></div>
                        </div>
                        <div
                          className={"row justify-content-end m-0 pb-2 pl-5"}
                        >
                          <span
                            style={{ width: "auto" }}
                            onClick={() => toggleDetails(s.id)}
                          >
                            {s.showDetails ? (
                              <ArrowCircleUp
                                style={{
                                  width: "2.5rem",
                                  height: "2.5rem",
                                  cursor: "pointer",
                                }}
                              />
                            ) : (
                              <ArrowCircleDown
                                style={{
                                  width: "2.5rem",
                                  height: "2.5rem",
                                  cursor: "pointer",
                                }}
                              />
                            )}
                          </span>
                        </div>
                      </Box>
                      <Box
                        sx={{
                          display: {
                            xs: "block",
                            sm: "block",
                            md: "none",
                            lg: "none",
                          },
                          marginTop: "8px",
                        }}
                        className={classes.cart}
                      >
                        <div className="row justify-content-center w-100 ml-0 mr-0">
                          <Grid xs={6} sm={6}>
                            مدل خودرو
                          </Grid>
                          <Grid xs={6} sm={6}>
                            {s.brand}/{s.carModel}/{s.carType}
                          </Grid>
                        </div>
                        <div className="row justify-content-center w-100 ml-0 mr-0">
                          <Grid xs={6} sm={6}>
                            کارکرد
                          </Grid>
                          <Grid xs={6} sm={6}>
                            {" "}
                            {s.mileage === "0" ? "صفر" : "کارکرده"}
                          </Grid>
                        </div>
                        <div className="row justify-content-center w-100 ml-0 mr-0">
                          <Grid xs={6} sm={6}>
                            سال ساخت
                          </Grid>
                          <Grid xs={6} sm={6}>
                            {s.persianYear}
                          </Grid>
                        </div>
                        <div className="row justify-content-center w-100 ml-0 mr-0">
                          <Grid xs={6} sm={6}>
                            موجودی
                          </Grid>
                          <Grid xs={6} sm={6}>
                            {s.count}
                          </Grid>
                        </div>
                        <div
                          className={"row justify-content-end m-0 pb-2 pl-5"}
                        >
                          <span
                            style={{ width: "auto" }}
                            onClick={() => toggleDetails(s.id)}
                          >
                            {s.showDetails ? (
                              <ArrowCircleUp
                                style={{
                                  width: "2.5rem",
                                  height: "2.5rem",
                                  cursor: "pointer",
                                }}
                              />
                            ) : (
                              <ArrowCircleDown
                                style={{
                                  width: "2.5rem",
                                  height: "2.5rem",
                                  cursor: "pointer",
                                }}
                              />
                            )}
                          </span>
                        </div>
                      </Box>
                      {s.showDetails && (
                        <div className={[classes.cart, "mt-2 p-3"].join(" ")}>
                          <Grid
                            lg={2}
                            md={3}
                            sm={12}
                            xs={12}
                            className="m-auto"
                          >
                            <GeneralButton
                              clicked={() => {
                                setModalContent(
                                  <>
                                    <div style={{ fontSize: 18 }}>
                                      واحد فروش و عملیات:
                                    </div>
                                    <div className="row justify-content-center">
                                      {console.log(webInfos)}
                                      {webInfos?.telephone && (
                                        <>
                                          <a
                                            style={{
                                              padding: 0,
                                              fontSize: 18,
                                              textAlign: "left",
                                              width: "auto",
                                            }}
                                            href={`tel:${webInfos?.telephone}`}
                                          >
                                            {webInfos?.telephone}
                                          </a>
                                        </>
                                      )}
                                      {webInfos?.mobile1 && (
                                        <a
                                          style={{
                                            padding: 0,
                                            fontSize: 18,
                                            textAlign: "left",
                                            width: "auto",
                                          }}
                                          href={`tel:${webInfos?.mobile1}`}
                                        >
                                          {webInfos?.mobile1}
                                        </a>
                                      )}
                                    </div>
                                  </>
                                );
                                setVisibleModal(true);
                              }}
                              btnType="BlueBtn"
                              text="تماس بگیرید"
                            />
                          </Grid>
                        </div>
                      )}
                    </>
                  );
                })}
                {!loading && salesOrders?.length == 0 && (
                  <Box
                    sx={{ textAlign: "center" }}
                    className={[
                      classes.cart,
                      "mt-5 justify-content-center p-5",
                    ].join(" ")}
                  >
                    خودروی مورد نظر یافت نشد.
                  </Box>
                )}
              </Box>
            </div>
          </div>
        </div>
      </div>
      <Modal
        open={visibleModal}
        close={() => setVisibleModal(false)}
        content={moodalContent}
      />
    </>
  );
};
export default Stock;
